module.exports = __webpack_public_path__ + "static/img/ng.b9197e69.svg";